<script lang="ts">
	import ChevronRight from '$lib/assets/images/icons/chevron-right.svg?component';
	import { hasTouchSupport } from '$lib/utils/helpers/hasTouchSupport';
	import { onMount } from 'svelte';
	import { twMerge } from 'tailwind-merge';

	export let id: string | null = null;
	export let name: string;
	export let value: string | null = '';
	export let disabled = false;
	export let placeholder: string | null = null;
	export let options: { label: string; value: string | number | boolean }[] = [];

	let className: string = '';
	export { className as class };

	let selectEntered = false;
	let isPhone: boolean;
	onMount(() => {
		isPhone = hasTouchSupport();
	});
</script>

<div class="relative">
	<select
		{id}
		{name}
		bind:value
		{disabled}
		class={twMerge(
			`w-full cursor-pointer appearance-none rounded-xl bg-inactive p-5 text-lg font-semibold text-slate-inactive outline-none transition-colors duration-300 disabled:opacity-100`,
			className
		)}
		on:change
		on:change={(e) => {
			const target = e.target;
			target.dataset.change = true;
		}}
		on:click={(e) => {
			if (!disabled) selectEntered = true;
			if (!isPhone && !e.target.dataset.change) {
				e.target?.dispatchEvent(new Event('change'));
			}
			e.target.dataset.change = false;
		}}
		on:change
		on:blur={() => {
			if (!disabled) selectEntered = false;
		}}
		{placeholder}
	>
		<option class="select-none" value="">{placeholder}</option>
		{#each options as option}
			<option value={option.value}>{@html option.label}</option>
		{/each}
	</select>
	<span
		class="pointer-events-none absolute right-0 top-0 flex h-full w-16 items-center justify-center"
	>
		<ChevronRight
			class="h-4 {!selectEntered
				? 'rotate-90'
				: 'rotate-[270deg]'} stroke-dark stroke-[8px] transition-transform"
		/>
	</span>
</div>
